import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { DropdownField, useFormField } from '@frontend/design-system';
import { StatusBadge } from '../../../components/status-badge';

type Props = {
  field: ReturnType<typeof useFormField<'dropdown'>>;
};

export const AvailabilityRequestSourceDropdown = ({ field }: Props) => {
  const { t } = useTranslation('schedule');

  return (
    <DropdownField
      {...field}
      name='requestSource'
      label=''
      css={styles.container}
      startAdornment={
        <div css={styles.startAdornment}>
          <Icon name='view' size={16} color='light' />
          <span css={styles.label}>{t('Visible to:')}</span>
        </div>
      }
    >
      <DropdownField.Option value='INTERNAL'>
        <StatusBadge variant='staff-only' />
      </DropdownField.Option>
      <DropdownField.Option value='AIR'>
        <StatusBadge variant='ai-receptionist' />
      </DropdownField.Option>
      <DropdownField.Option value='BOOKING_SITE'>
        <StatusBadge variant='online-scheduling' />
      </DropdownField.Option>
    </DropdownField>
  );
};

const styles = {
  container: css`
    min-width: fit-content;
    height: 32px;
    padding-left: 0;
    padding-right: var(--fabric-space-padding-xs);
    & > p {
      padding-right: var(--fabric-space-padding-xxs);
    }
  `,
  startAdornment: css`
    display: flex;
    align-items: center;
    gap: var(--fabric-space-gap-xxs);
    flex-shrink: 0;
    background-color: ${theme.colors.white};
    padding: var(--fabric-space-padding-xxs) var(--fabric-space-padding-xs);
    box-sizing: border-box;
  `,
  label: css`
    font-size: var(--fabric-font-size-sm);
    white-space: nowrap;
    font-weight: bold;
  `,
};
